module.exports={
	"Form": "ProductionPlantEditManifest",
	"Scope": "ProductionPlant-Edit",
	"Descriptors":
	{
		"ProductionPlantDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProductionPlant-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ProductionPlant-Edit-Identity",
				"Group": "ProductionPlant-Edit-Identity"
			}
		},
		"ProductionPlantDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "ProductionPlant-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "ProductionPlant-Edit-Details",
				"Group": "ProductionPlant-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"ProductionPlantDetails.IDOrganizationAddress":
		{
			"Name": "Organization Address",
			"Hash": "ProductionPlant-Edit-IDOrganizationAddress",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "ProductionPlant-Edit-Details",
				"Group": "ProductionPlant-Edit-Details",
				"Entity": "OrganizationAddress",
				"SearchFields":
				[
					"LocationName"
				]
			}
		},
		"ProductionPlantDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "ProductionPlant-Edit-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "ProductionPlant-Edit-Details",
				"Group": "ProductionPlant-Edit-Details"
			}
		},
		"ProductionPlantDetails.ExternalProductionPlantID":
		{
			"Name": "External Production Plant ID",
			"Hash": "ProductionPlant-Edit-ExternalProductionPlantID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProductionPlant-Edit-Details",
				"Group": "ProductionPlant-Edit-Details"
			}
		},
		"ProductionPlantDetails.IDProductionPlant":
		{
			"Name": "IDProduction Plant",
			"Hash": "ProductionPlant-Edit-IDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProductionPlant-Edit-DataAudit",
				"Group": "ProductionPlant-Edit-DataAudit"
			}
		},
		"ProductionPlantDetails.GUIDProductionPlant":
		{
			"Name": "GUIDProduction Plant",
			"Hash": "ProductionPlant-Edit-GUIDProductionPlant",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProductionPlant-Edit-DataAudit",
				"Group": "ProductionPlant-Edit-DataAudit"
			}
		},
		"ProductionPlantDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "ProductionPlant-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "ProductionPlant-Edit-DataAudit",
				"Group": "ProductionPlant-Edit-DataAudit"
			}
		},
		"ProductionPlantDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "ProductionPlant-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProductionPlant-Edit-DataAudit",
				"Group": "ProductionPlant-Edit-DataAudit"
			}
		},
		"ProductionPlantDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "ProductionPlant-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProductionPlant-Edit-DataAudit",
				"Group": "ProductionPlant-Edit-DataAudit"
			}
		},
		"ProductionPlantDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "ProductionPlant-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "ProductionPlant-Edit-DataAudit",
				"Group": "ProductionPlant-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProductionPlant-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProductionPlant-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "ProductionPlant-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "ProductionPlant-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "ProductionPlant-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "ProductionPlant-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
